module.exports = __webpack_public_path__ + "img/bills.e1e02bc6.svg";